export default "__VITE_ASSET__BpQIfLu4__"